/**
 * HumaniseFileSize
 *
 * @description Format bytes as human-readable text.
 * @param {number} bytes         Number of bytes.
 * @param {number} decimalPlaces Number of decimal places to display.
 * @returns {string} Formatted string.
 * @see https://stackoverflow.com/a/14919494
 */
export const humaniseFileSize = (bytes: number, decimalPlaces = 1): string => {
  const thresh = 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + ' B';
  }

  const units = ['kB', 'MB', 'GB'];

  let arrayIndex = -1;
  const percentage = 10 ** decimalPlaces;

  do {
    bytes /= thresh;
    ++arrayIndex;
  } while (
    Math.round(Math.abs(bytes) * percentage) / percentage >= thresh &&
    arrayIndex < units.length - 1
  );

  return `${bytes.toFixed(decimalPlaces)} ${units[arrayIndex]}`;
};